import {Router} from '@angular/router';
import {Navigator, NavigatorWith2Params, NavigatorWithParam} from './navigators/navigators';
import { Injectable } from "@angular/core";

@Injectable()
export abstract class NavService {
  constructor(protected router: Router) {}

  protected makeNavigator(...subroutes: string[]): Navigator {
    return new Navigator(this.router, ...subroutes);
  }

  protected makeNavigatorWithParam<T>(...subroutes: string[]): NavigatorWithParam<T> {
    return new NavigatorWithParam<T>(this.router, ...subroutes);
  }

  protected makeNavigatorWith2Params<T, U>(...subroutes: string[]): NavigatorWith2Params<T, U> {
    return new NavigatorWith2Params<T, U>(this.router, ...subroutes);
  }
}
